import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pwm211Api, FM030, QueryRequest } from '../../../services/pwm211Api';

interface QueryState {
  results: FM030[];
  total: number;
  loading: boolean;
  page: number;
  pageSize: number;
  filters: QueryRequest;
}

export function usePWM211Query() {
  const [state, setState] = useState<QueryState>({
    results: [],
    total: 0,
    loading: false,
    page: 1,
    pageSize: 50,
    filters: {},
  });

  // Execute query with current filters
  const executeQuery = useCallback(
    async (filters?: QueryRequest, page?: number, pageSize?: number) => {
      const f = filters ?? state.filters;
      const p = page ?? state.page;
      const ps = pageSize ?? state.pageSize;
      setState(prev => ({ ...prev, loading: true, filters: f, page: p, pageSize: ps }));
      try {
        const res = await pwm211Api.list(f, p, ps);
        setState(prev => ({
          ...prev,
          results: res.data ?? [],
          total: res.total,
          loading: false,
        }));
      } catch {
        message.error('查詢失敗，請稍後再試');
        setState(prev => ({ ...prev, loading: false }));
      }
    },
    [state.filters, state.page, state.pageSize]
  );

  const setFilter = useCallback((key: keyof QueryRequest, value: string) => {
    setState(prev => ({ ...prev, filters: { ...prev.filters, [key]: value } }));
  }, []);

  const resetFilters = useCallback(() => {
    setState(prev => ({ ...prev, filters: {}, results: [], total: 0 }));
  }, []);

  return {
    results: state.results,
    total: state.total,
    loading: state.loading,
    page: state.page,
    pageSize: state.pageSize,
    filters: state.filters,
    executeQuery,
    setFilter,
    resetFilters,
  };
}
